module.exports = __webpack_public_path__ + "img/progress.53977ec3.gif";